import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import EcommerceSolutions from './components/EcommerceSolutions';
import Benefits from './components/Benefits';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": `${siteUrl}/#organization`,
          "name": "Hommen Consulting GmbH",
          "url": siteUrl,
          "logo": {
            "@type": "ImageObject",
            "url": "https://static.readdy.ai/image/535cd5cb202604744f94f7b2225e7be8/507ad711238d1ff66498f69658d73c1b.png"
          },
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Westring 32",
            "addressLocality": "Brüggen",
            "postalCode": "41379",
            "addressCountry": "DE"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "availableLanguage": ["de", "en"]
          }
        },
        {
          "@type": "WebSite",
          "@id": `${siteUrl}/#website`,
          "url": siteUrl,
          "name": "Hommen Consulting GmbH",
          "publisher": {
            "@id": `${siteUrl}/#organization`
          }
        },
        {
          "@type": "ProfessionalService",
          "@id": `${siteUrl}/#service`,
          "name": "Hommen Consulting GmbH",
          "image": "https://static.readdy.ai/image/535cd5cb202604744f94f7b2225e7be8/507ad711238d1ff66498f69658d73c1b.png",
          "url": siteUrl,
          "telephone": "",
          "priceRange": "$$",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Westring 32",
            "addressLocality": "Brüggen",
            "postalCode": "41379",
            "addressCountry": "DE"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 51.2417,
            "longitude": 6.1833
          },
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday"
            ],
            "opens": "09:00",
            "closes": "17:00"
          },
          "serviceType": "E-Commerce Buchführung & Tax Compliance",
          "areaServed": {
            "@type": "Country",
            "name": "Germany"
          }
        },
        {
          "@type": "BreadcrumbList",
          "@id": `${siteUrl}/#breadcrumb`,
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": siteUrl
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    script.id = 'schema-org-home';
    document.head.appendChild(script);

    return () => {
      const existingScript = document.getElementById('schema-org-home');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Hero isScrolled={isScrolled} />
      <Services />
      <EcommerceSolutions />
      <Benefits />
      <Testimonials />
      <Contact />
    </div>
  );
}